import { Plus } from "@phosphor-icons/react";

export const AdjustmentForm = ({ emps, form, setForm, onSubmit }) => (
  <form onSubmit={onSubmit} className="flex flex-wrap items-end gap-3">
    <div className="flex-1 min-w-[180px]">
      <label className="text-xs font-semibold text-stone-500">Employee</label>
      <select required value={form.user_id} onChange={(e) => setForm({ ...form, user_id: e.target.value })} data-testid="adjustment-employee-select"
        className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
        <option value="">Select…</option>
        {emps.map((e) => <option key={e.id} value={e.id}>{`${e.name} (${e.employee_code})`}</option>)}
      </select>
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Type</label>
      <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="adjustment-type-select"
        className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
        <option value="reimbursement">Reimbursement</option>
        <option value="deduction">Deduction</option>
      </select>
    </div>
    <div className="flex-1 min-w-[160px]">
      <label className="text-xs font-semibold text-stone-500">Label</label>
      <input required placeholder="Travel reimbursement" value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} data-testid="adjustment-label-input"
        className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Amount (₹)</label>
      <input type="number" min="1" step="0.01" required value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} data-testid="adjustment-amount-input"
        className="mt-1 block w-28 min-h-[44px] px-3 rounded-lg border border-stone-300 text-right" />
    </div>
    <button type="submit" data-testid="add-adjustment-button"
      className="tap-scale flex items-center gap-1 px-5 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200"><Plus size={16} weight="bold" /> Add</button>
  </form>
);
